/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FunctionComponent, useCallback } from 'react';
import GraphImg from '@graphcms/react-image';
import { Skeleton } from '@doveit/bricks';
import Link from 'next/link';
import * as styles from './ArticleSmallCard.style';
import { goToPage, URLObject } from '../../utils/links';

export interface ArticleSmallCardProps {
  title: string,
  dataRef?: string,
  date?: string,
  urlObject: URLObject,
  onClick?: (path: string) => void,
  thumbnail?: {
    handle: string,
    alt: string,
    url?: string,
  },
}

export const ArticleSmallCardSkeleton = () => (
  <div css={styles.base}>
    <div css={styles.thumbnail}>
      <Skeleton
        width={styles.THUMBNAIL_WIDTH}
        height={styles.THUMBNAIL_HEIGHT}
      />
    </div>
    <div css={styles.info}>
      <Skeleton count={2} />
    </div>
  </div>
);

const ArticleSmallCard: FunctionComponent<ArticleSmallCardProps> = ({
  title,
  dataRef = 'article-small-card',
  urlObject,
  onClick,
  date,
  thumbnail,
}) => {
  const internalOnClick = useCallback((path: string) => () => {
    if (onClick) {
      onClick(path);
    } else {
      goToPage(urlObject);
    }
  }, [onClick, urlObject]);

  return (
    <article
      css={styles.base}
      dataRef={dataRef}
      onClick={internalOnClick(urlObject.as)}
    >
      <div css={styles.thumbnail}>
        {thumbnail && thumbnail.handle && (
          <GraphImg
            image={{
              handle: thumbnail.handle,
              width: 180,
              height: 120,
            }}
            maxWidth={180}
            alt={thumbnail.alt || title}
            title={thumbnail.alt || title}
            blurryPlaceholder={false}
            backgroundColor
            fadeIn={false}
          />
        )}
      </div>
      <div css={styles.info}>
        <div>
          <Link
            href={urlObject.url}
            as={urlObject.as}
          >
            {title}
          </Link>
        </div>
        {date && (
          <time css={styles.details}>
            {date}
          </time>
        )}
      </div>
    </article>
  );
};

export default ArticleSmallCard;
